/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { AbilityBuilder, Ability } from "@casl/ability";
import {
  ADMIN_CANNOT_ABILITY,
  ADMIN_CAN_ABILITY,
  COMMITTEE_CANNOT_ABILITY,
  COMMITTEE_CAN_ABILITY,
  MASQUERADER_CANNOT_ABILITY,
  MASQUERADER_CAN_ABILITY,
  CASHIER_CAN_ABILITY,
  CASHIER_CANNOT_ABILITY,
  SUPER_ADMIN_CAN_ABILITY,
  SUPER_ADMIN_CANNOT_ABILITY,
  SUPERVISOR_CAN_ABILITY,
  SUPERVISOR_CANNOT_ABILITY,
  CASHIER_SUPERVISOR_CAN_ABILITY,
  CASHIER_SUPERVISOR_CANNOT_ABILITY,
  REPORT_ADMIN_CANNOT_ABILITY,
  REPORT_ADMIN_CAN_ABILITY,
  ROAD_SUPPORT_CAN_ABILITY,
  ROAD_SUPPORT_CANNOT_ABILITY,
} from "./index";

export const defineAbilityFor = (whoami: string) => {
  const ability: any = new AbilityBuilder(Ability);

  console.log("whooami2", whoami);
  if (whoami === "owner") {
    ability.can("manage", "all"); // read-write access to everything
  } else if (whoami === "admin") {
    ADMIN_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    ADMIN_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "superAdmin") {
    SUPER_ADMIN_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    SUPER_ADMIN_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "masq") {
    MASQUERADER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    MASQUERADER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "committeeMember") {
    COMMITTEE_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    COMMITTEE_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "cashier") {
    CASHIER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    CASHIER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "roadSupport") {
    ROAD_SUPPORT_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    ROAD_SUPPORT_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "supervisor") {
    SUPERVISOR_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    SUPERVISOR_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "cashSupervisor") {
    CASHIER_SUPERVISOR_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    CASHIER_SUPERVISOR_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === "production") {
    REPORT_ADMIN_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    REPORT_ADMIN_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else {
    ability.cannot("read", "all"); // read-only access to everything
  }

  return ability.build();
};
